var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-left"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-right"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-650 -320)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(650 320)",
    clipPath: "url(#clip-path-left)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.556 28.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.163,0,0,36.414V56.582L99.163,20.168Z",
    transform: "translate(99.163 56.582) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.322,20.168V0L99.159,36.414,0,72.829V93L99.159,56.582Z",
    transform: "translate(198.323 137.815) rotate(180)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(650 320)",
    clipPath: "url(#clip-path-right)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.557 33.052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.322,0,99.159,36.414,0,72.829V93L99.159,56.582l99.163-36.414Z",
    transform: "translate(198.322 92.997) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.163,0,0,36.414V56.582L99.163,20.168Z",
    transform: "translate(198.886 138.375) rotate(180)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.0d9299c3f2194079bb83bc08d34cdbe4.svg";
export { ForwardRef as ReactComponent };